/**
 * The SIGN ONLY JS application of Flow Service.
 *
 * @author Documill
 */
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import apiCall from './utils/api';
import SmartTable from 'vuejs-smart-table';
import simplebar from 'simplebar-vue';
import 'simplebar/dist/simplebar.min.css';
import i18n from './i18n';
import { showDocumillToast, mountDocumillToastContainer, addDocumillTooltip, removeDocumillTooltip, mountDocumillTooltipContainer, mountDropdownContainer } from 'documill-ui-library';
import VueKonva from 'vue-konva';

let app = createApp(App);

/* vuejs logger related constants */
const isProduction = process.env.NODE_ENV === 'production';

app.use(router);
app.use(store);
app.use(SmartTable);
app.use(i18n);
app.use(VueKonva)

app.config.globalProperties.$apiCall = apiCall;
app.component('simplebar', simplebar);

// mount the container.
mountDocumillToastContainer();
// Make the function available globally in the project
app.config.globalProperties.$showDocumillToast = showDocumillToast;

// Mount the tooltip container.
mountDocumillTooltipContainer(app, { offset: 8 });

// Mount the dropdown container. Pass the Vuex store instace so that components rendered inside
// the Dropdown container have access to the same store.
mountDropdownContainer(store);

app.mount('#app')

/* :) */
/* ASCII from https://www.text-image.com/convert/ascii.html */

let documillLogo = '\n'+
'        `+dddd/ :yddhs/`\n'+
'       :ssyddd++ssshdddd+`\n'+
'          :ddd/     .odddy`\n'+
'          :ddd/       :ddds\n'+
'          :ddd/       `hddd\n'+
'```````   :ddd/       -ddds\n'+
'`/oooo+   :ddd/     `+dddh.\n'+
'  `:oo+   :dddyooosydddds`\n'+
'    `:+   :ddddddddddy+.\n'+
'      `   `--------.`\n';

console.log(documillLogo);
console.log("Documill");
